import { MatSort } from '@angular/material/sort';
import { SaleHorseRepoContactResponseDto } from '../../models/sales/sale-contacts.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class ContactHorsesListDataSource extends MatDataSource<SaleHorseRepoContactResponseDto> {

  public constructor(
    data: SaleHorseRepoContactResponseDto[],
    sort: MatSort,
    disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20
  ) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }
  public applyDefaultSort() {
    if (this.sort) {
      this.sort.active = 'lotNumber'; // Set default sorting
      this.sort.direction = 'asc';
      this.sort.sortChange.emit(this.sort);
    }
  }
  private sortOn: string;

  public setSortOn(sortOn: string) {
    this.sortOn = sortOn;
  }
  // Custom sort method for a specific column (e.g., 'horseName')
  setCustomSort(): void {
    this.sortingDataAccessor = (saleHorse: SaleHorseRepoContactResponseDto, sortHeaderId: string): any => {
      if (sortHeaderId === 'horseName') {
        if (this.sortOn == 'horse') {
          return saleHorse.horseName?.toLowerCase();
        }
        if (this.sortOn == 'sire') {
          return saleHorse.sire?.toLowerCase();
        }
        if (this.sortOn == 'dam') {
          return saleHorse.dam?.toLowerCase();
        }
      }
      // Default sorting for other columns
      return saleHorse[sortHeaderId as keyof SaleHorseRepoContactResponseDto];
    };
  }
  setFilterPredicate(): void {
    this.filterPredicate = (saleHorse: SaleHorseRepoContactResponseDto, filterValue: string = '') => {
      return 'lot,lotNumber,horseName,consignor,sire,dam'
        .split(',')
        .some((key) => {
          return (
            saleHorse[key as keyof SaleHorseRepoContactResponseDto] &&
            new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
              String(saleHorse[key as keyof SaleHorseRepoContactResponseDto] ?? '')
            )
          );
        });
    };
  }
}
